import { useDynamicData, useCurrentCurrency } from '@avensia/excite';
import { useLoadScriptOnScreen } from '@avensia/excite-ui';
import * as React from 'react';

type Props = {
  galleryId: string;
  productId?: string;
  dynamicallySetProductId?: boolean;
  hidePrices?: boolean;
};
const options = {
  attributes: {
    id: 'cevoidScriptTag',
    type: 'module',
  },
  async: true,
};

function onScriptLoaded() {
  const container = document.getElementById('cevoid-container');
  const shouldLoad = window.CookieInformation && window.CookieInformation?.getConsentGivenFor('cookie_cat_functional');
  if (!container?.hasChildNodes() && window.cevoid_gallery && shouldLoad) {
    window.cevoid_gallery.load();
  }
}

export default React.memo(({ galleryId, productId, dynamicallySetProductId, hidePrices }: Props) => {
  const ref = useLoadScriptOnScreen<HTMLDivElement>('https://gallery.cevoid.com/index.js', { options, onScriptLoaded });

  const [scriptSettings] = useDynamicData<NordicNest.Api.ScriptSettingsApiModel>();
  const currentCurrency = useCurrentCurrency();
  const currencyMarkets = scriptSettings?.cevoidCurrencyMarkets
    ? JSON.parse(scriptSettings?.cevoidCurrencyMarkets)
    : undefined;
  const currencyMarket = currencyMarkets ? currencyMarkets[currentCurrency] ?? '' : '';

  return (
    <div
      id="cevoid-container"
      ref={ref}
      data-gallery={galleryId}
      data-product={dynamicallySetProductId ? productId : ''}
      data-market={scriptSettings?.cevoidMarketId ?? ''}
      data-market-currency={currencyMarket}
      data-hide-prices={hidePrices ?? false}
    />
  );
});
